module.exports = __webpack_public_path__ + "static/img/logo.77cbba96.png";